/**
 * Composable wrapper for a row of filter controls (search, dropdowns, etc.).
 * @param {{ children: React.ReactNode, className?: string }} props
 */
export default function FilterBar({ children, className = '' }) {
  return (
    <div className={`flex flex-wrap gap-3 mb-4 ${className}`}>
      {children}
    </div>
  );
}
